import React from 'react';
import { Link } from 'react-router-dom';
import { validate, validators } from 'validate-redux-form';
import { Field, reduxForm } from 'redux-form';
import { AsyncSelectField, renderField, renderNumberKG } from '../../../../Utils/renderField/renderField';
import { api } from "api";
import { positiveNumberField } from '../../../../../../utility/getErrors';
import './PackingForm.css';

const getTransports = (search) => {
    return api.get("transport", { search }).then((data) => {
        if (data) return data.results;
        return [];
    }).catch(() => {
        return [];
    });
};


const getProduct = (search) => {
    return api.get("packing/get_product_for_packing", { search }).then((data) => {
        if (data) return data.results;
        return [];
    }).catch(() => {
        return [];
    });
};

let PackingForm = props => {
    const { handleSubmit, isEdit } = props;
    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container packing-form">
                <div className="d-flex justify-content-center">
                    <br />
                    <br />
                </div>
                <div className="row  col-md-12 p-0">
                    <div className="col-md-6 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="name" className="m-0">NOMBRE</label>
                        </div>
                        <div className="col-md-12  form-group">
                            <Field name="name" component={renderField} type="text" className="form-control" placeholder='Nombre' />
                        </div>
                    </div>
                    <div className="col-md-6 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="storage_capacity" className="m-0">CAPACIDAD DE ALMACENAMIENTO</label>
                        </div>
                        <div className="col-md-12  form-group">
                            <Field
                                name="storage_capacity"
                                component={renderNumberKG}
                                type="number"
                                placeholder='0.00'
                                className="form-control"
                                validate={[positiveNumberField]}
                            />
                        </div>
                    </div>
                </div>
                <div className="row  col-md-12 p-0">
                    <div className="col-md-6 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="rol" className="m-0">TIPO DE TRANSPORTE</label>
                        </div>
                        <div className="col-md-12  form-group">
                            <Field
                                valueKey="id"
                                name="type_of_transport"
                                labelKey="name"
                                label="name"
                                component={AsyncSelectField}
                                loadOptions={getTransports}
                                disabled={isEdit}
                                className="form-control"
                            />
                        </div>
                    </div>
                    <div className="col-md-6 p-0">
                        <div className="col-md-12 col-sm-12">
                            <label htmlFor="rol" className="m-0">PRODUCTO</label>
                        </div>
                        <div className="col-md-12  form-group">
                            <Field
                                valueKey="id"
                                name="type_of_product"
                                labelKey="name"
                                label="name"
                                component={AsyncSelectField}
                                loadOptions={getProduct}
                                disabled={isEdit}
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>

                <div className="buttons-box mt-5">
                    <Link className="btn btn-outline-dark mx-3 mb-3" to="/packings">CANCELAR</Link>

                    <button type="submit" className="btn btn-primary mx-3 mb-3">GUARDAR</button>
                </div>
            </div>
        </form>
    )
};
PackingForm = reduxForm({
    form: 'EditarPackingForm',
    validate: data => {
        return validate(data, {
            'name': validators.exists()('Campo requerido.'),
            'storage_capacity': validators.exists()('Campo requerido.'),
            'type_of_transport': validators.exists()('Campo requerido.'),
            'type_of_product': validators.exists()('Campo requerido.'),

        })
    }
})(PackingForm);
export const PackingUpdateForm = reduxForm({
    form: 'EditarPackingForm',
    validate: data => {
        return validate(data, {
            'name': validators.exists()('Campo requerido.'),
            'storage_capacity': validators.exists()('Campo requerido.'),
            'type_of_transport': validators.exists()('Campo requerido.'),
            'type_of_product': validators.exists()('Campo requerido.'),
        })
    },
    asyncBlurFields: []
})(PackingForm);

export default PackingForm
